var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1289_39593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 35.5783C27.7083 35.5783 35.5783 27.7083 35.5783 18.0001C35.5783 8.29192 27.7083 0.421875 18.0001 0.421875C8.29192 0.421875 0.421875 8.29192 0.421875 18.0001C0.421875 27.7083 8.29192 35.5783 18.0001 35.5783Z",
    fill: "#2B306C"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1289_39593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4298 20.7255C26.1996 21.4771 27.0121 22.1842 27.7025 23.0116C28.0075 23.3792 28.2962 23.7586 28.5171 24.1853C28.8301 24.7919 28.5466 25.4594 28.0028 25.4956L24.6219 25.494C23.75 25.5664 23.0544 25.2154 22.4695 24.6192C22.0014 24.1424 21.5679 23.635 21.1178 23.1421C20.9333 22.9407 20.7402 22.7511 20.5094 22.6013C20.0479 22.3017 19.6473 22.3934 19.3836 22.8748C19.1149 23.3644 19.054 23.9065 19.0276 24.4521C18.9914 25.2482 18.7508 25.4575 17.9511 25.494C16.2421 25.5746 14.6201 25.316 13.1134 24.4539C11.785 23.6938 10.7549 22.6209 9.85829 21.4062C8.1126 19.0409 6.77575 16.4418 5.57423 13.77C5.30378 13.168 5.50157 12.8448 6.16576 12.8334C7.26869 12.812 8.37146 12.8135 9.47568 12.8319C9.92394 12.8384 10.2207 13.0955 10.3938 13.519C10.9905 14.9863 11.7206 16.3822 12.6371 17.6761C12.8812 18.0206 13.1301 18.3651 13.4845 18.6076C13.8766 18.876 14.1751 18.7871 14.3595 18.3503C14.4765 18.0734 14.5278 17.7751 14.5542 17.4785C14.6415 16.4581 14.6531 15.4394 14.4998 14.4226C14.4057 13.7879 14.0483 13.3771 13.415 13.257C13.0919 13.1958 13.14 13.0756 13.2965 12.8911C13.5682 12.573 13.8238 12.375 14.3333 12.375H18.1541C18.7557 12.4937 18.8892 12.7639 18.9716 13.3692L18.9749 17.6134C18.9683 17.8477 19.0919 18.543 19.5139 18.6981C19.8517 18.8085 20.0744 18.5383 20.277 18.3241C21.1918 17.3531 21.8448 16.2057 22.4281 15.0175C22.6869 14.4951 22.9095 13.9525 23.1252 13.4104C23.285 13.0081 23.5358 12.8101 23.9889 12.8189L27.6663 12.8222C27.7753 12.8222 27.8856 12.8238 27.9912 12.8419C28.6109 12.9475 28.7807 13.214 28.5893 13.8191C28.2878 14.7685 27.701 15.5596 27.1274 16.3545C26.5141 17.203 25.8582 18.0225 25.2501 18.8761C24.6913 19.6556 24.7357 20.0485 25.4298 20.7255Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1289_39593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1289_39593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2068,
    height: 23.2068,
    fill: "white",
    transform: "translate(5.45703 7.33789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVk);
export default __webpack_public_path__ + "static/media/icon-VK.f7f720d0c514f8276718737bfc212907.svg";
export { ForwardRef as ReactComponent };